"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RibbonProps_1 = require("./RibbonProps");
var styles = require("./Ribbon.css");
var Ribbon = /** @class */ (function (_super) {
    __extends(Ribbon, _super);
    function Ribbon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ribbon.prototype.render = function () {
        var className = styles.emptyRibbon;
        var ribbonText = '';
        if (this.props.data && this.props.data.text) {
            className = styles.ribbon;
            ribbonText = this.props.data.text;
        }
        if (this.props.type === RibbonProps_1.RibbonType.RECOMMENDED) {
            className = styles.ribbonRecommended;
        }
        return (React.createElement("div", { "data-test-id": this.props.testId, className: className }, ribbonText));
    };
    return Ribbon;
}(React.Component));
exports.default = Ribbon;
//# sourceMappingURL=Ribbon.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ribbon/Ribbon.js
// module id = 1235
// module chunks = 8